<template>
  <BaseSelect v-model="currentlySelectedOption" :options="selectStringColumnOperators" :append-to-body="true"></BaseSelect>
  <BaseInput
    v-if="stringFilter.option === StringColumnOperators.STARTS_WITH"
    v-model="singleValueInput"
    :placeholder="t('genericTable.enterProp', { description: props.description })"
  >
  </BaseInput>
  <BaseInput
    v-else-if="stringFilter.option === StringColumnOperators.ENDS_WITH"
    v-model="singleValueInput"
    :placeholder="t('genericTable.enterProp', { description: props.description })"
  >
  </BaseInput>
  <BaseInput
    v-else-if="stringFilter.option === StringColumnOperators.CONTAINS"
    v-model="singleValueInput"
    :placeholder="t('genericTable.enterProp', { description: props.description })"
  >
  </BaseInput>
  <BaseInput
    v-else-if="stringFilter.option === StringColumnOperators.EXACT"
    v-model="singleValueInput"
    :placeholder="t('genericTable.enterProp', { description: props.description })"
  >
  </BaseInput>
  <BaseSelect
    v-else-if="stringFilter.option === StringColumnOperators.IN"
    v-model="arrayValueInput"
    mode="tags"
    :placeholder="t('genericTable.stringFilter.enterValues', { description: props.description })"
    :append-to-body="true"
    searchable
    :is-clearable="true"
    :create-option="true"
  >
  </BaseSelect>
  <MissingValueFilter
    v-else-if="stringFilter.option === CommonColumnOperators.VALUE_EXISTS"
    v-model="stringFilter"
  ></MissingValueFilter>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BaseInput from "../../../../components/BaseInput.vue";
import BaseSelect from "../../../../components/BaseSelect.vue";
import { CommonColumnOperators, StringColumnOperators } from "../../enum.filterOperators";
import { StringFilterType } from "../../type.genericTableQuery";
import MissingValueFilter from "./ValueExistsFilter.vue";
const stringFilterType = defineModel<StringFilterType>({ required: true });
const stringFilter = computed(() => stringFilterType.value.filter);

const props = defineProps<{ description: string }>();
const { t } = useI18n();
const selectStringColumnOperators = [
  { value: StringColumnOperators.STARTS_WITH, label: t("genericTable.stringFilter.startsWith") },
  { value: StringColumnOperators.ENDS_WITH, label: t("genericTable.stringFilter.endsWith") },
  { value: StringColumnOperators.CONTAINS, label: t("genericTable.stringFilter.contains") },
  { value: StringColumnOperators.EXACT, label: t("genericTable.stringFilter.exact") },
  { value: StringColumnOperators.IN, label: t("genericTable.stringFilter.in") },
  { value: CommonColumnOperators.VALUE_EXISTS, label: t("genericTable.valueExistsFilter.valueExists") },
];

const currentlySelectedOption = computed({
  get() {
    return stringFilter.value.option;
  },
  set(newOption) {
    if (newOption !== stringFilter.value.option) {
      stringFilter.value.value = undefined;
      stringFilter.value.option = newOption;
    }
  },
});

const singleValueInput = computed({
  get: () => (typeof stringFilter.value.value === "string" ? stringFilter.value.value : ""),
  set: (val: string) => {
    stringFilter.value.value = val === "" ? undefined : val;
  },
});

const arrayValueInput = computed({
  get: () => (Array.isArray(stringFilter.value.value) ? stringFilter.value.value : []),
  set: (val: string[]) => {
    stringFilter.value.value = val.length === 0 ? undefined : val;
  },
});
</script>
